// @flow
import MESSAGES from 'core/data-model/constants/bi-messages'
import type { InsuredProps } from 'core/service/pdf-generation/products/common/types'

export const getInsuredFullName = ({ firstName, lastName }: InsuredProps = {}) => {
  return [firstName || MESSAGES.DEFAULT_FIRSTNAME, lastName || MESSAGES.DEFAULT_LASTNAME].join(' ')
}
